import { context } from './context';

import { createProviderFromContext } from '../create-provider-from-context';

export const RedirectProvider = createProviderFromContext(context);
